// extracted by mini-css-extract-plugin
export var downArrow = "_9h-0";
export var label = "_9h-1";
export var treatmentCard = "_9h-3";
export var upArrow = "_9h-2";